export { HeroStandard } from './HeroStandard';
export type { Props as HeroStandardProps } from './HeroStandard';
